export default function Footer() {
  return (
    <footer className="bg-gray-200 p-6 text-center text-sm text-gray-600">
      <div className="container">
        © 2025 ISKROVKA. All rights reserved.
      </div>
    </footer>
  );
}